import React from 'react';

import './intro-text.scss';

const IntroText = () => {
   return (
      <div className="intro-text d-flex flex-column justify-content-center align-items-center ps-1">
         <p>Hard-working software developer with ability to create elegant solutions using industry programming standards. Developed an e-commerce web application for Inheritance Publications resulting in nearly 100% positive feedbacks from customers, and a minesweeper game for my siblings, friends and myself. Passionate about web development, and the quick and beautiful results that come from it.</p>

         <p>Goal: to fill a software developer position in a company with an environment that drives its members to learn and improve skills, such as writing efficient code with use of the various techniques and principles used in the industry in order to become proficient in developing complex, performant and scalable apps and services.</p>
      </div>
   )
}

export default IntroText
